import { makeVar } from '@apollo/client'

export const emailValue = makeVar<string>('')
export const passwordValue = makeVar<string>('')
export const fundNameValue = makeVar<string>('')
export const userUuidValue = makeVar<string>('')
